import React from 'react';
import { BorrowerList } from '../components/BorrowerList';
export function Dashboard() {
  return <div className="min-h-screen bg-gray-50" data-id="element-245">
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10" data-id="element-246">
        {/* Page Header */}
        <div className="mb-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-247">
          <div data-id="element-248">
            <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-249">
              Division Performance Dashboard
            </h1>
            <p className="text-gray-500 mt-1 text-base" data-id="element-250">
              Managerial view across all divisions
            </p>
          </div>
          <div className="flex items-center gap-2.5 text-sm bg-white px-4 py-2.5 rounded-lg border border-gray-200 shadow-sm text-gray-600 whitespace-nowrap" data-id="element-251">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse flex-shrink-0" data-id="element-252" />
            Market rates dropped 0.125% today
          </div>
        </div>

        {/* Accordion Table with embedded summary tiles */}
        <BorrowerList data-id="element-253" />
      </main>
    </div>;
}